import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "sub",
  "use": "sub-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"sub\"><defs><style type=\"text/css\"></style></defs><path d=\"M834.56 97.28H189.44c-51.2 0-97.28 40.96-97.28 97.28v640c0 51.2 40.96 97.28 97.28 97.28h640c51.2 0 97.28-40.96 97.28-97.28V189.44c0-51.2-40.96-92.16-92.16-92.16z m-5.12 460.8H194.56c-20.48 0-40.96-20.48-40.96-40.96s20.48-40.96 40.96-40.96h634.88c20.48 0 40.96 20.48 40.96 40.96 0 25.6-20.48 40.96-40.96 40.96z\" p-id=\"4918\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id